import React from 'react';
import { Helmet } from 'react-helmet-async';

const ReviewSchema = ({ testimonials = [] }) => {
  if (!testimonials || testimonials.length === 0) return null;

  const reviewSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://loveyuhlife.ca/#organization",
    "name": "LOVEYUHLIFE INC",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": testimonials.length,
      "bestRating": "5",
      "worstRating": "5"
    },
    "review": testimonials.map((testimonial, index) => ({
      "@type": "Review",
      "@id": `https://loveyuhlife.ca/reviews/${index + 1}`,
      "author": {
        "@type": "Person",
        "name": testimonial.name
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": testimonial.rating || 5,
        "bestRating": "5",
        "worstRating": "1"
      },
      "reviewBody": testimonial.text,
      "publisher": {
        "@type": "Organization",
        "name": testimonial.company || "Client Business"
      },
      "datePublished": testimonial.created_at || "2024-01-01",
      "reviewAspect": "Service Quality"
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(reviewSchema)}
      </script>
    </Helmet>
  );
};

export default ReviewSchema;